import React from "react";
import Tabla from "./Tabla";

function TrackingSesiones(props) {
  return <Tabla {...props} />;
}

export default TrackingSesiones;
